module.exports = __webpack_public_path__ + "img/guide2_m.8f024b1a.jpg";